// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__MxETp","inner":"Footer_inner__3iu9s"};